import { SEND_APPLICATION_INVITATION } from '../../constants/requests';
import { INVITE_TO_APPLY_MODAL_REQUEST_CLOSE } from '../../constants/actions';

const initialState = null;

export default function newInviteStatus(state = initialState, action) {
  switch (action.type) {
    case INVITE_TO_APPLY_MODAL_REQUEST_CLOSE:
    case SEND_APPLICATION_INVITATION.REQUEST:
      return initialState;
    case SEND_APPLICATION_INVITATION.RECEIVE:
      return 'success';
    case SEND_APPLICATION_INVITATION.FAILURE:
      return 'failure';
    default:
      return state;
  }
}
